import React from "react";

function Working({ data }) {
  return (
    <section className="layout-section">
      <div className="layout-container">
        <h1 id="heading-large" className="text-center mb-8">
          How It Works
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {data.map((item, index) => (
            <div key={index} className="relative text-center sm:text-left">
              <div className="w-8 h-8 mx-auto sm:mx-0 mb-3 flex items-center justify-center bg-blue-500 text-white rounded-full font-semibold text-sm">
                {index + 1}
              </div>
              <h2 id="heading-md" className="mb-2">
                {item.heading}
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Working;
